import { httpClient } from "../funcs"

export const DEMO_SERVICES_TEMPLATE_NAME = "Пример: оказание услуг"

const DEMO_SERVICES_COMMENT =
    "Универсальный пример, не ваш договор. Можно подписать себя и посмотреть, как это работает."

const DEMO_SERVICES_BODY = `
<p><strong>Пример договора оказания услуг</strong></p>
<p>Это универсальный пример, чтобы посмотреть подписание. Это не ваш договор.</p>
<p>Исполнитель оказывает Заказчику услугу: {{Услуга}}.</p>
<p>Срок оказания услуг: с {{Дата начала}} по {{Дата окончания}}.</p>
<p>Стоимость услуг составляет {{Сумма}} руб.</p>
<p>Заказчик: {{ФИО клиента}}, телефон {{Телефон клиента}}.</p>
`

function demoField(type: string, keyword: string, extra: Record<string, unknown> = {}) {
    return {
        type,
        keyword,
        value: "",
        description: "",
        editable: true,
        hidden: false,
        isRequired: true,
        userPath: "",
        validationRule: "",
        needNumberToWords: false,
        ...extra,
    }
}

export function hidePassportSystemEntities(systemEntities: any[]): any[] {
    return (systemEntities ?? []).map((entity: any) => {
        if (String(entity?.id ?? "").startsWith("client_passport")) {
            return { ...entity, hidden: true }
        }
        return entity
    })
}

async function findExistingDemoServicesTemplate(): Promise<string> {
    try {
        const { data } = await httpClient.get("/templates", {
            params: { offset: 0, search_query: DEMO_SERVICES_TEMPLATE_NAME },
        })
        const payload = data as { templates?: any[] } | any[]
        const list = Array.isArray(payload) ? payload : (payload.templates ?? [])
        const found = list.find((template: any) => (
            template?.source === "demo_services"
            || template?.name === DEMO_SERVICES_TEMPLATE_NAME
        ))
        return found?._id ? String(found._id) : ""
    } catch {
        return ""
    }
}

async function createDemoServicesTemplateViaScratch(): Promise<string> {
    const { data: created } = await httpClient.post("/new-template-from-scratch")
    if (!created?._id) {
        return ""
    }
    await httpClient.post(`/template/${created._id}`, {
        name: DEMO_SERVICES_TEMPLATE_NAME,
        comment: DEMO_SERVICES_COMMENT,
        body: DEMO_SERVICES_BODY,
        entities: JSON.stringify([
            demoField("Текст", "Услуга"),
            demoField("Дата", "Дата начала"),
            demoField("Дата", "Дата окончания"),
            demoField("Текст", "Сумма", { needNumberToWords: true }),
        ]),
        system_entities: JSON.stringify(hidePassportSystemEntities(created.system_entities ?? [])),
        guides: created.guides ?? [],
        settings: JSON.stringify(created.settings ?? {}),
    })
    return String(created._id)
}

export async function ensureDemoServicesTemplate(): Promise<string> {
    const existing = await findExistingDemoServicesTemplate()
    if (existing) {
        return existing
    }
    try {
        const { data } = await httpClient.post("/new-demo-services-template")
        if (data?._id) {
            return String(data._id)
        }
    } catch (error: any) {
        const status = error?.response?.status ?? error?.status
        if (status && status !== 404) {
            throw error
        }
    }
    return createDemoServicesTemplateViaScratch()
}
